import { useTranslation } from 'react-i18next';

/**
 * 3-2-1 카운트다운 — 녹음이 열리기 직전의 오버레이(덱 p7 "측정 전").
 *
 * 큰 숫자는 `aria-hidden`이고 읽히는 건 문장 쪽이다: 스크린리더에 "3"만 던지면 그게
 * 카운트다운인지 측정값인지 알 수 없다. 매 초 문장이 바뀌므로 `assertive`로 끊어 읽힌다 —
 * 이 안내는 늦게 도착하면 쓸모가 없다.
 */

export const CountdownOverlay = ({ count }: { count: number }) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-live="assertive"
      // 딤이지 가림막이 아니다(시안) — 뒤의 안내 문구와 트랙이 비쳐야 무엇을 준비하는
      // 화면인지 읽힌다. 불투명하게 덮으면 3초 동안 화면이 사라진 것처럼 보인다.
      className="absolute inset-0 z-20 flex items-center justify-center bg-foreground/30"
    >
      <span className="sr-only">
        {t('web.diagnosis.countdown.announce', { value: count })}
      </span>
      <span
        aria-hidden="true"
        className="text-8xl font-bold tabular-nums leading-none text-foreground motion-safe:animate-pulse"
      >
        {count}
      </span>
    </div>
  );
};
